import { transformers } from './index';

export default function(response, sportType) {
  if (transformers[sportType]) {
    return transformers[sportType](response);
  }
  return response;
}
